/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentData as AgentApiContractAgentData } from '../../models/AgentApi/Contract/agent-data';

export interface ApiAgentGetAgentDataGet$Params {

/**
 * Interface language
 */
  lang?: string;

/**
 * agent id
 */
  slrId?: number;
}

export function apiAgentGetAgentDataGet(http: HttpClient, rootUrl: string, params?: ApiAgentGetAgentDataGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAgentData>> {
  const rb = new RequestBuilder(rootUrl, apiAgentGetAgentDataGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('slrId', params.slrId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractAgentData>;
    })
  );
}

apiAgentGetAgentDataGet.PATH = '/api/Agent/GetAgentData';
